import React, { Children, PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '@duel/icon';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import designTokens from '@duel/core/design-tokens';
import styles from './Button.scss';

export default class Button extends PureComponent {
	static propTypes = {
		children: PropTypes.node.isRequired,
		className: PropTypes.string,
		disabled: PropTypes.bool,
		element: PropTypes.oneOf(['button', 'div', 'label', 'span']),
		formType: PropTypes.oneOf(['button', 'submit', 'reset']),
		processing: PropTypes.bool,
		tagId: PropTypes.string,
		type: PropTypes.oneOf([
			'default',
			'primary',
			'primary-outline',
			'transactional',
			'transactional-outline',
			'success',
			'success-outline',
			'warn',
			'warn-outline',
			'danger',
			'danger-outline'
		])
	};

	static defaultProps = {
		element: 'button',
		formType: 'button',
		type: 'default'
	};

	render() {
		const {
			children,
			className,
			element,
			formType,
			processing,
			tagId,
			type,
			...elementProps
		} = this.props;

		elementProps.className = cx(
			'c-button',
			`x-${type}`,
			processing && styles.processing,
			className
		);

		if (element === 'button') {
			elementProps.type = formType;
		}

		return (
			<TransitionGroup
				component={element}
				{...elementProps}
				data-dsx-button={tagId}
				data-tag-button={true}>
				<CSSTransition timeout={0}>
					<span className={styles.contents}>
						{Children.map(children, child =>
							typeof child === 'string' ? <span>{child}</span> : child
						)}
					</span>
				</CSSTransition>
				{processing && (
					<CSSTransition
						classNames={{
							enter: styles.loadingEnter,
							enterActive: styles.loadingEnterActive,
							exit: styles.loadingExit
						}}
						timeout={designTokens['motion-duration-transition'] * 1.5}>
						<span className={styles.loading}>
							<Icon type="loading" />
						</span>
					</CSSTransition>
				)}
			</TransitionGroup>
		);
	}
}
